module.exports = __webpack_public_path__ + "img/4.ba5e0819.png";